export const tickerItems = [
  "12:47 顾南弦 新剧《破晓西风》官宣开机，进组路透释出",
  "12:32 苏晚晴 舞台直拍播放量 12 小时破 500 万",
  "12:18 《高能唱作人》决赛夜阵容抢先曝光，今晚开播",
  "11:56 林屿舟 生日当天空降粉丝群，晒手写回信",
  "11:40 程野 巡回演唱会上海站加场官宣",
  "11:22 乔安可 全新代言物料深夜上线，造型引爆讨论",
  "10:58 时遥 综艺《慢行时光》飞行嘉宾路透流出",
  "10:37 白砚 新杂志封面花絮释出，双生主题引热议",
];

export const trackingTopics = [
  {
    tag: "#星海拾光·双男主营业",
    heat: 1,
    name: "林屿舟 × 顾南弦",
    label: "剧集营业",
    ep: "更新至 18 / 24 话",
    pct: 75,
    comment: "昨晚更新的花絮片段冲上热一，正主营业频率拉满",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20portrait%2C%20two%20young%20actors%20in%20silhouette%20facing%20each%20other%2C%20warm%20amber%20rim%20light%20against%20deep%20red%20studio%20backdrop%2C%20film%20grain%2C%20moody%20and%20stylish%2C%20plain%20dark%20background%2C%20no%20text&width=720&height=720&seq=track-scoop-01&orientation=squarish",
  },
  {
    tag: "#全能唱作人·决赛夜",
    heat: 2,
    name: "苏晚晴",
    label: "综艺赛果",
    ep: "更新至 12 / 决赛",
    pct: 100,
    comment: "决赛曲单曝光，网传与顶级制作人合作",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20of%20a%20young%20female%20singer%20backlit%20on%20stage%2C%20spotlight%20halo%2C%20warm%20amber%20and%20red%20wash%2C%20film%20grain%2C%20cinematic%2C%20plain%20dark%20stage%20background%2C%20no%20text&width=720&height=720&seq=track-scoop-02&orientation=squarish",
  },
  {
    tag: "#逆风翻盘·大结局",
    heat: 3,
    name: "程野",
    label: "剧综收官",
    ep: "已更新 40 / 40 话",
    pct: 100,
    comment: "会员收官夜已更，大结局彩蛋引发二刷潮",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20portrait%20of%20a%20young%20man%20in%20a%20tailored%20coat%2C%20half%20in%20shadow%2C%20warm%20window%20light%2C%20film%20grain%2C%20plain%20warm%20grey%20studio%20background%2C%20stylish%2C%20no%20text&width=720&height=720&seq=track-scoop-03&orientation=squarish",
  },
  {
    tag: "#顾南弦·新剧进组",
    heat: 4,
    name: "顾南弦",
    label: "资源更新",
    ep: "追踪中 · 片场照 06",
    pct: 42,
    comment: "开机路透持续更新，古装造型先睹为快",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20costume%20test%20portrait%2C%20young%20actor%20in%20hanfu%2C%20dramatic%20warm%20side%20light%2C%20deep%20red%20backdrop%2C%20film%20grain%2C%20cinematic%2C%20no%20text&width=720&height=720&seq=track-scoop-04&orientation=squarish",
  },
  {
    tag: "#程野·巡演官宣",
    heat: 5,
    name: "程野 巡回演唱会",
    label: "行程商务",
    ep: "官宣 6 城 · 抢票中",
    pct: 66,
    comment: "新巡演视觉海报释出，票务压力预警",
    image:
      "https://readdy.ai/api/search-image?query=concert%20promo%20editorial%20stylized%20art%2C%20single%20figure%20backlit%20by%20floodlight%20on%20empty%20stage%2C%20red%20and%20amber%20gradient%2C%20atmospheric%20haze%2C%20film%20grain%2C%20no%20text&width=720&height=720&seq=track-scoop-05&orientation=squarish",
  },
  {
    tag: "#乔安可·代言之争",
    heat: 6,
    name: "乔安可",
    label: "商务资源",
    ep: "商代追踪 · 更新 03",
    pct: 33,
    comment: "高奢成衣线物料连更，商务风向再起波澜",
    image:
      "https://readdy.ai/api/search-image?query=fashion%20editorial%20portrait%20of%20young%20woman%20in%20oversized%20blazer%2C%20backlit%20warm%20studio%20light%2C%20red%20toned%20backdrop%2C%20film%20grain%2C%20minimal%20and%20stylish%2C%20no%20text&width=720&height=720&seq=track-scoop-06&orientation=squarish",
  },
];

export const hotScoops = [
  {
    tag: "恋情",
    rank: 1,
    title: "林屿舟 深夜同返公寓画面流出，女方身份成最大悬念",
    sub: "连续三晚被拍同行，双方团队至今未回应，蹲料区吵成一团",
    minutes: "刚刚",
    comment: 4821,
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20nocturnal%20editorial%20still%2C%20two%20silhouettes%20walking%20under%20warm%20streetlight%2C%20blurred%20city%20night%2C%20red%20and%20amber%20tones%2C%20heavy%20film%20grain%2C%20moody%20journalistic%20candid%20feel%2C%20no%20text&width=1200&height=760&seq=scoop-big-01&orientation=landscape",
  },
  {
    tag: "翻车",
    rank: 2,
    title: "《逆风翻盘》男主戏外言行被扒，人设与采访严重对不上",
    sub: "旧采访连环打脸，粉丝站集体脱粉边缘",
    minutes: "18 分钟前",
    comment: 3126,
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20close%20up%20of%20a%20press%20microphone%20and%20reporters%20in%20blur%2C%20warm%20tungsten%20light%2C%20red%20wash%2C%20film%20grain%2C%20documentary%20candid%2C%20no%20text&width=560&height=520&seq=scoop-mid-02&orientation=landscape",
  },
  {
    tag: "营业",
    rank: 3,
    title: "苏晚晴 深夜直播开嗓，被爆已在筹备第二张专辑",
    sub: "一句新歌快好了冲上热搜，粉丝开始倒计时",
    minutes: "1 小时前",
    comment: 2568,
    image:
      "https://readdy.ai/api/search-image?query=live%20stream%20set%20editorial%2C%20neon%20ring%20light%20glow%2C%20microphone%20close%20up%2C%20warm%20red%20and%20amber%20color%20wash%2C%20cinematic%20film%20grain%2C%20no%20text&width=560&height=520&seq=scoop-mid-03&orientation=landscape",
  },
  {
    tag: "舞台",
    rank: 4,
    title: "《高能唱作人》决赛夜今晚开播，曲目单提前外泄",
    sub: "赛制临时改动被质疑剧本，导演组深夜发文回应",
    minutes: "2 小时前",
    comment: 1943,
    image:
      "https://readdy.ai/api/search-image?query=music%20variety%20finale%20stage%2C%20empty%20spotlit%20stage%20with%20warm%20amber%20lights%2C%20fog%2C%20deep%20red%20backdrop%2C%20cinematic%20film%20grain%2C%20no%20text&width=560&height=520&seq=scoop-mid-04&orientation=landscape",
  },
  {
    tag: "代言",
    rank: 5,
    title: "乔安可 新代言官宣前夜，物料被曝临时更换艺人",
    sub: "前一位候选人的开拍计划被否，圈内人疯狂暗指",
    minutes: "3 小时前",
    comment: 1580,
    image:
      "https://readdy.ai/api/search-image?query=glossy%20advertising%20product%20shoot%20set%2C%20softbox%20light%2C%20perfume%20bottle%20on%20red%20silk%2C%20warm%20cinematic%20lighting%2C%20film%20grain%2C%20no%20text&width=560&height=520&seq=scoop-mid-05&orientation=landscape",
  },
];

export const flashItems = [
  { time: "13:02", type: "路透", text: "顾南弦《破晓西风》新造型路透再+2，头套服装均有变化", hot: 999 },
  { time: "12:47", type: "商务", text: "乔安可 珠宝线代言高糊物料流出，同款耳坠被扒出同款", hot: 887 },
  { time: "12:35", type: "直播", text: "苏晚晴 直播间观众突破 300 万，唱了三首未公开 demo", hot: 812 },
  { time: "12:19", type: "行程", text: "程野 官宣 6 城巡演，上海场 2 秒售罄引质疑", hot: 766 },
  { time: "11:58", type: "综艺", text: "《慢行时光》飞行嘉宾名单更新，时遥确认参加下期录制", hot: 654 },
  { time: "11:41", type: "杂志", text: "白砚 封面花絮释出，双生主题内页被指影射新戏人设", hot: 598 },
  { time: "11:25", type: "互动", text: "林屿舟 生日手写回信扫图流出，字迹被粉丝逐字解读", hot: 543 },
  { time: "11:07", type: "音乐", text: "苏晚晴 新专辑制作人被拍到现身录音棚，二专或实锤", hot: 489 },
  { time: "10:52", type: "红毯", text: "下周电影节红毯名单泄露，多家工作室急辟谣", hot: 432 },
  { time: "10:36", type: "剧组", text: "《逆风翻盘》疑似筹备番外篇，编剧深夜关注超话", hot: 388 },
];

export const peekBoards = [
  {
    type: "恋情瓜",
    when: "预计明晚 20:00",
    title: "顶流男星新恋情方向锁定，女方圈内素人二选一",
    desc: "线人称手中握有高清同框，正在谈置换条件，明晚开砸",
    lock: 12800,
    image:
      "https://readdy.ai/api/search-image?query=dark%20mystery%20editorial%20still%2C%20silhouetted%20couple%20far%20apart%20under%20street%20lights%2C%20red%20and%20amber%20tones%2C%20film%20grain%2C%20suspense%20journalistic%20feel%2C%20no%20text&width=640&height=440&seq=peek-01&orientation=landscape",
  },
  {
    type: "赛果瓜",
    when: "预计今晚 22:30",
    title: "《高能唱作人》决赛冠军方向已出，与赔率大相径庭",
    desc: "投票通道数据异常，多方渠道交叉印证今晚爆冷",
    lock: 10120,
    image:
      "https://readdy.ai/api/search-image?query=trophy%20and%20spotlight%20on%20dark%20stage%2C%20amber%20bokeh%2C%20suspenseful%20red%20wash%2C%20film%20grain%2C%20editorial%2C%20no%20text&width=640&height=440&seq=peek-02&orientation=landscape",
  },
  {
    type: "资源瓜",
    when: "预计后天 12:00",
    title: "乔安可 被曝拿下某高奢全系代言，资源迎来转机",
    desc: "品牌方物料档期已排好，只待官宣窗口",
    lock: 8640,
    image:
      "https://readdy.ai/api/search-image?query=lavish%20gold%20and%20red%20luxury%20product%20still%2C%20silk%20fabric%2C%20soft%20dramatic%20light%2C%20film%20grain%2C%20editorial%2C%20no%20text&width=640&height=440&seq=peek-03&orientation=landscape",
  },
  {
    type: "剧集瓜",
    when: "预计明早 10:00",
    title: "《破晓西风》阵容或有惊喜加码，网传视帝客串大反派",
    desc: "片场进出记录被拍到，服化道同步出现高规格配置",
    lock: 7320,
    image:
      "https://readdy.ai/api/search-image?query=film%20set%20clapperboard%20and%20period%20costume%20rack%2C%20warm%20practical%20lights%2C%20red%20accent%2C%20cinematic%20film%20grain%2C%20editorial%2C%20no%20text&width=640&height=440&seq=peek-04&orientation=landscape",
  },
];

export const collageWall = [
  {
    label: "热搜后遗症",
    theme: "爆",
    title: "双男主营业上限在哪，正主比我们还懂套路",
    chat: "9.2k",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20double%20exposure%20of%20two%20actor%20silhouettes%20back%20to%20back%2C%20warm%20red%20and%20amber%20gradient%2C%20film%20grain%2C%20stylish%20topic%20collage%20feel%2C%20no%20text&width=640&height=420&seq=wall-01&orientation=landscape",
  },
  {
    label: "翻红考古",
    theme: "热",
    title: "从糊剧到翻身，一部古早作品如何被挖成顶流",
    chat: "7.1k",
    image:
      "https://readdy.ai/api/search-image?query=vintage%20analog%20photo%20collage%2C%20old%20television%20static%20and%20film%20stills%20in%20warm%20faded%20tones%2C%20red%20wash%2C%20film%20grain%2C%20nostalgic%20editorial%2C%20no%20text&width=640&height=420&seq=wall-02&orientation=landscape",
  },
  {
    label: "塌房避险",
    theme: "新",
    title: "人设崩塌前的那些信号，这份预警清单建议收藏",
    chat: "6.4k",
    image:
      "https://readdy.ai/api/search-image?query=warning%20themed%20editorial%20still%2C%20broken%20spotlight%20and%20shattered%20glass%20reflections%2C%20deep%20red%20and%20amber%2C%20dramatic%20film%20grain%2C%20no%20text&width=640&height=420&seq=wall-03&orientation=landscape",
  },
  {
    label: "红毯修罗场",
    theme: "热",
    title: "历届红毯死亡打光盘点，谁被拍到想报警",
    chat: "5.8k",
    image:
      "https://readdy.ai/api/search-image?query=red%20carpet%20editorial%20mosaic%2C%20glare%20flares%20and%20flashes%2C%20elegant%20silhouette%2C%20warm%20red%20lighting%2C%20film%20grain%2C%20no%20text&width=640&height=420&seq=wall-04&orientation=landscape",
  },
  {
    label: "站姐手记",
    theme: "专",
    title: "追更内幕话术拆解：瓜主可信度如何分级",
    chat: "4.9k",
    image:
      "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20notebook%20and%20camera%20lens%2C%20warm%20desk%20light%2C%20red%20accent%2C%20film%20grain%2C%20documentary%20editorial%2C%20no%20text&width=640&height=420&seq=wall-05&orientation=landscape",
  },
  {
    label: "数据撕榜",
    theme: "爆",
    title: "榜单水分几何，脱水之后谁才是真断层",
    chat: "4.2k",
    image:
      "https://readdy.ai/api/search-image?query=data%20graphics%20collage%20in%20warm%20monochrome%2C%20rising%20bars%20and%20sparklines%2C%20deep%20red%20backdrop%2C%20film%20grain%2C%20editorial%20data%20visual%2C%20no%20text&width=640&height=420&seq=wall-06&orientation=landscape",
  },
];

export const topicCloud = [
  { name: "#双男主营业", type: "剧集", count: 328, trend: 3 },
  { name: "#塌房预警", type: "翻车", count: 297, trend: 5 },
  { name: "#专辑二专", type: "音乐", count: 264, trend: 2 },
  { name: "#决赛夜赛果", type: "综艺", count: 251, trend: 4 },
  { name: "#巡演抢票", type: "行程", count: 218, trend: 1 },
  { name: "#高奢代言", type: "商务", count: 197, trend: 6 },
  { name: "#新剧进组", type: "剧集", count: 186, trend: 7 },
  { name: "#红毯名单", type: "红毯", count: 162, trend: 8 },
  { name: "#同款物料", type: "营业", count: 149, trend: 9 },
  { name: "#直播开嗓", type: "舞台", count: 133, trend: 10 },
  { name: "#杂志封面", type: "杂志", count: 121, trend: 11 },
  { name: "#粉丝站", type: "社群", count: 105, trend: 12 },
];

export const heroMini = [
  { name: "林屿舟 新恋情", state: "蹲更中", hot: 98 },
  { name: "全能唱作人 决赛", state: "今晚开", hot: 95 },
  { name: "乔安可 新代言", state: "快实锤", hot: 90 },
];